import React, { useRef } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import template from "../../../../assets/template/template.png";

export default function ImageDataModal({ id, addId, modalOpen, setModalOpen }) {
  const modalContent = useRef(null);

  return (
    <div
      onClick={(e) => {
        if (e.target.id !== "allow-img") {
          setModalOpen(false);
        }
      }}
    >
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        //id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white overflow-auto max-w-4xl w-full max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="flex space-x-4">
            <div>
              <img
                src={template}
                alt="sample template"
                id="allow-img"
                width="1000"
                height="600"
              />
            </div>
          </div>
        </div>
      </CssTransition>
    </div>
  );
}
